export default __webpack_public_path__ + "static/media/shop-happy-hormones-en.3a8aa039.png";